exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-container-btn{width:200px!important}.m-pop{padding:0}.m-pop .el-cascader-panel{position:relative}.m-pop .el-cascader-panel .desc{position:absolute;left:100%;transform:translateX(1px)}.m-pop .el-cascader-menu{padding-bottom:20px}.m-pop .el-cascader-menu .el-cascader-menu__wrap{min-height:250px;max-height:350px;overflow-x:hidden;width:310px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0193644a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SubCascader/VueMenuCascader.vue
// module id = 13
// module chunks = 0